/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flat_Sandy_Swan_DartInputs */

const en_flat_sandy_swan_dart = /** @type {(inputs: Flat_Sandy_Swan_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

const de_flat_sandy_swan_dart = /** @type {(inputs: Flat_Sandy_Swan_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprache`)
};

/**
* | output |
* | --- |
* | "Language" |
*
* @param {Flat_Sandy_Swan_DartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flat_sandy_swan_dart = /** @type {((inputs?: Flat_Sandy_Swan_DartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Sandy_Swan_DartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flat_sandy_swan_dart(inputs)
	return de_flat_sandy_swan_dart(inputs)
});